import React, { useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Paper,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Button,
} from "@material-ui/core";
import { eventParticipants } from "../../../../../data-store/actions/registry-actions";
import { updateEventAttribute } from "../../../../../data-store/actions/events-actions";
import {
  recalcularVendidosDesdeInscritos,
  productosDeFuentes,
  VALOR_PRODUCTO_COMPLETO,
} from "./inventoryLogic";

export default function InventoryReconcile() {
  const dispatch = useDispatch();
  const eventDetail = useSelector((state) => state.events.eventDetail);
  const registryConfiguration = useSelector(
    (state) => state.registry.registryConfiguration
  );
  const eventParticipantsState = useSelector(
    (state) => state.registry.eventParticipants
  );
  const eventParticipantsRequested = useSelector(
    (state) => state.registry.eventParticipantsRequested
  );
  const eventParticipantsEventIndex = useSelector(
    (state) => state.registry.eventParticipantsEventIndex
  );

  const eventoIndex = "evento_" + eventDetail.iDEvento;
  const inventarios = registryConfiguration.inventarios;

  function cargarInscritos() {
    dispatch(eventParticipants(eventoIndex));
  }

  const yaCargado =
    eventParticipantsRequested && eventParticipantsEventIndex === eventoIndex;

  const conteosCalculados = useMemo(() => {
    if (!yaCargado || !inventarios) return null;
    return recalcularVendidosDesdeInscritos(inventarios, eventParticipantsState);
  }, [yaCargado, inventarios, eventParticipantsState]);

  function actualizarContador(itemKey, opcionKey, nuevoValor) {
    const ruta =
      "inscripcionesConfiguracion/inventarios/" + itemKey + "/opciones/" + opcionKey + "/";
    dispatch(updateEventAttribute(eventoIndex, ruta, { vendidos: nuevoValor }));

    // Se evalúa aquí mismo, igual que al guardar un item, para que "agotado"
    // quede correcto de inmediato sin esperar al backend (que además se
    // encarga de ocultar la opción/producto en la vista pública).
    const item = inventarios[itemKey];
    const opcion = item.opciones[opcionKey];
    const capacidad = Number(opcion.capacidad) || 0;
    const agotado = capacidad > 0 && nuevoValor >= capacidad;
    if (agotado !== (opcion.agotado === true)) {
      dispatch(updateEventAttribute(eventoIndex, ruta, { agotado }));
    }

    // Si esta opción representa un producto completo, refleja el mismo
    // estado en agotadoInventario del producto (lo que usa CardProduct).
    const valoresOrigen = opcion.valoresOrigen || {};
    if (valoresOrigen[VALOR_PRODUCTO_COMPLETO]) {
      productosDeFuentes(item.fuentes, registryConfiguration).forEach((productoKey) => {
        dispatch(
          updateEventAttribute(
            eventoIndex,
            "inscripcionesConfiguracion/productosAdicionales/" + productoKey + "/",
            { agotadoInventario: agotado }
          )
        );
      });
    }
  }

  if (!inventarios || Object.keys(inventarios).length === 0) {
    return null;
  }

  return (
    <Paper style={{ padding: 20, marginTop: 20 }}>
      <Typography gutterBottom variant={"h5"} component="h2">
        Reconciliar inventario con inscritos
      </Typography>
      {!yaCargado && (
        <Button variant="contained" color="primary" onClick={cargarInscritos}>
          Recalcular desde inscritos
        </Button>
      )}
      {yaCargado && conteosCalculados && (
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Item</TableCell>
              <TableCell>Opción</TableCell>
              <TableCell>Guardado</TableCell>
              <TableCell>Calculado</TableCell>
              <TableCell>Diferencia</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Object.keys(inventarios).map((itemKey) =>
              Object.keys(inventarios[itemKey].opciones || {}).map((opcionKey) => {
                const opcion = inventarios[itemKey].opciones[opcionKey];
                const calculado = conteosCalculados[itemKey]
                  ? conteosCalculados[itemKey][opcionKey] || 0
                  : 0;
                const guardado = opcion.vendidos || 0;
                const diferencia = calculado - guardado;
                return (
                  <TableRow key={itemKey + "|" + opcionKey}>
                    <TableCell>{inventarios[itemKey].nombre}</TableCell>
                    <TableCell>{opcion.nombre}</TableCell>
                    <TableCell>{guardado}</TableCell>
                    <TableCell>{calculado}</TableCell>
                    <TableCell style={{ color: diferencia !== 0 ? "#c62828" : "inherit" }}>
                      {diferencia}
                    </TableCell>
                    <TableCell>
                      {diferencia !== 0 && (
                        <Button
                          size="small"
                          variant="outlined"
                          onClick={() =>
                            actualizarContador(itemKey, opcionKey, calculado)
                          }
                        >
                          Actualizar
                        </Button>
                      )}
                    </TableCell>
                  </TableRow>
                );
              })
            )}
          </TableBody>
        </Table>
      )}
    </Paper>
  );
}
